export default __webpack_public_path__ + "static/media/9.b5f661a7.svg";